exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-user-selector-filter-right .yxt-form-clamp{display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:2;word-break:break-all;word-wrap:break-word;-webkit-box-orient:vertical}\n", ""]);

